/**
 * ROHO Theme JavaScript
 * Handles all interactive functionality
 */

(function() {
  'use strict';

  // ============================================
  // TRANSPARENT HEADER SCROLL
  // ============================================
  function initTransparentHeader() {
    var header = document.querySelector('.header');
    if (!header) return;

    var isTransparent = header.hasAttribute('data-header-transparent');
    var scrollThreshold = isTransparent ? 80 : 10;
    var ticking = false;

    function onScroll() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          if (window.scrollY > scrollThreshold) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }
          ticking = false;
        });
        ticking = true;
      }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    // Run once on load in case page is already scrolled
    onScroll();
  }

  // ============================================
  // MOBILE MENU TOGGLE
  // ============================================
  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var nav = document.getElementById('HeaderNav');
    if (!toggle || !nav) return;

    toggle.addEventListener('click', function() {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      nav.classList.toggle('active');
      var icon = toggle.querySelector('i');
      if (icon) {
        icon.classList.toggle('fa-bars');
        icon.classList.toggle('fa-times');
      }
    });
  }

  // ============================================
  // PRODUCT IMAGE GALLERY
  // ============================================
  function initProductGallery() {
    var thumbnails = document.querySelectorAll('[data-thumbnail-index]');
    var mainImage = document.querySelector('[data-main-image]');
    if (!thumbnails.length || !mainImage) return;

    thumbnails.forEach(function(thumb) {
      thumb.addEventListener('click', function() {
        // Use the pre-built data-full-src from Liquid's image_url filter
        var fullSrc = this.getAttribute('data-full-src');
        if (fullSrc && mainImage.src !== fullSrc) {
          // Smooth fade transition
          mainImage.classList.add('switching');
          setTimeout(function() {
            mainImage.src = fullSrc;
            mainImage.onload = function() {
              mainImage.classList.remove('switching');
              mainImage.onload = null;
            };
          }, 150);
          var thumbImg = this.querySelector('img');
          mainImage.alt = thumbImg ? thumbImg.alt : '';
        }

        // Update active thumbnail
        thumbnails.forEach(function(t) { t.classList.remove('active'); });
        this.classList.add('active');
      });
    });
  }

  // Helper: switch main image to a specific media ID (used by variant selector)
  function switchToImage(mediaId) {
    if (!mediaId) return;
    var thumb = document.querySelector('[data-media-id="' + mediaId + '"]');
    if (thumb) {
      thumb.click();
      return;
    }
    // Fallback: use the image map built from Liquid
    var imageMap = window.productImageMap || {};
    var src = imageMap[mediaId];
    if (src) {
      var mainImage = document.querySelector('[data-main-image]');
      if (mainImage) mainImage.src = src;
    }
  }

  // ============================================
  // MOBILE IMAGE SWIPE GALLERY
  // ============================================
  function initMobileImageSlider() {
    var slider = document.querySelector('[data-mobile-slider]');
    if (!slider) return;

    var dots = document.querySelectorAll('[data-dot-index]');
    var slides = slider.querySelectorAll('.product__mobile-slide');
    if (slides.length <= 1) return;

    // Update dots on scroll
    var scrollTimer;
    slider.addEventListener('scroll', function() {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(function() {
        var slideWidth = slider.clientWidth;
        var activeIndex = Math.round(slider.scrollLeft / slideWidth);
        dots.forEach(function(dot, i) {
          dot.classList.toggle('active', i === activeIndex);
        });
      }, 50);
    }, { passive: true });

    // Click dots to navigate
    dots.forEach(function(dot) {
      dot.addEventListener('click', function() {
        var index = parseInt(this.getAttribute('data-dot-index'), 10);
        slider.scrollTo({ left: index * slider.clientWidth, behavior: 'smooth' });
      });
    });
  }

  // ============================================
  // SIZE ROW VISIBILITY (Type → Size toggle)
  // ============================================
  function initSizeRowVisibility() {
    var variantBtns = document.querySelectorAll('.product__variant-btn');
    if (!variantBtns.length) return;

    function updateSizeRowVisibility(typeValue) {
      var val = typeValue.toLowerCase().trim();
      var sizeRows = document.querySelectorAll('[data-size-type]');

      sizeRows.forEach(function(row) {
        var sizeType = row.getAttribute('data-size-type');

        if (val.indexOf('whole') !== -1 || val.indexOf('set') !== -1) {
          row.style.display = '';
        } else if (val.indexOf('top') !== -1) {
          row.style.display = (sizeType === 'top' || sizeType === 'both') ? '' : 'none';
        } else if (val.indexOf('pant') !== -1 || val.indexOf('bottom') !== -1) {
          row.style.display = (sizeType === 'pant' || sizeType === 'both') ? '' : 'none';
        } else {
          row.style.display = '';
        }
      });
    }

    // Set initial visibility from the first active button
    var initialActive = document.querySelector('.product__variant-btn.active');
    if (initialActive) {
      updateSizeRowVisibility(initialActive.getAttribute('data-option-value') || 'Whole Set');
    }

    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var group = this.closest('.product__variant-buttons');
        if (group) {
          group.querySelectorAll('.product__variant-btn').forEach(function(b) {
            b.classList.remove('active');
          });
        }
        this.classList.add('active');

        var optionValue = this.getAttribute('data-option-value');
        updateSizeRowVisibility(optionValue);
      });
    });
  }

  // ============================================
  // VARIANT / OPTION SELECTORS
  // ============================================
  function initVariantSelectors() {
    var productData = window.productData;
    if (!productData) return;

    var selectedOptions = {};

    // Find the current variant: check URL param first, then Liquid-provided ID, then fallback to first
    var currentVariant = null;
    var urlParams = new URLSearchParams(window.location.search);
    var urlVariantId = urlParams.get('variant');

    if (urlVariantId && productData.variants) {
      for (var v = 0; v < productData.variants.length; v++) {
        if (String(productData.variants[v].id) === urlVariantId) {
          currentVariant = productData.variants[v];
          break;
        }
      }
    }

    if (!currentVariant && window.currentVariantId && productData.variants) {
      for (var v2 = 0; v2 < productData.variants.length; v2++) {
        if (productData.variants[v2].id === window.currentVariantId) {
          currentVariant = productData.variants[v2];
          break;
        }
      }
    }

    if (!currentVariant && productData.variants && productData.variants.length > 0) {
      currentVariant = productData.variants[0];
    }

    // Initialize selected options from the current variant
    if (productData.options && currentVariant) {
      productData.options.forEach(function(optionName, i) {
        selectedOptions[optionName] = currentVariant['option' + (i + 1)];
      });
    }

    // Handle variant type buttons — update selectedOptions + variant on click
    var variantBtns = document.querySelectorAll('.product__variant-btn');
    variantBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var optionName = this.getAttribute('data-option-name');
        var optionValue = this.getAttribute('data-option-value');
        if (optionName) {
          selectedOptions[optionName] = optionValue;
          updateVariant(selectedOptions, productData);
        }
      });
    });

    // Handle size buttons
    var sizeBtns = document.querySelectorAll('.product__size-btn');
    sizeBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        if (this.classList.contains('disabled')) return;

        var row = this.closest('.product__size-row');
        if (row) {
          row.querySelectorAll('.product__size-btn').forEach(function(b) {
            b.classList.remove('active');
          });
        }
        this.classList.add('active');

        var optionName = this.getAttribute('data-option-name');
        var optionValue = this.getAttribute('data-option-value');
        if (optionName) {
          selectedOptions[optionName] = optionValue;
          updateVariant(selectedOptions, productData);
        }
      });
    });
  }

  function updateVariant(selectedOptions, productData) {
    if (!productData.variants) return;

    // Find matching variant
    var matchedVariant = null;
    for (var i = 0; i < productData.variants.length; i++) {
      var variant = productData.variants[i];
      var match = true;

      if (productData.options) {
        for (var j = 0; j < productData.options.length; j++) {
          var optionName = productData.options[j];
          if (selectedOptions[optionName] && variant['option' + (j + 1)] !== selectedOptions[optionName]) {
            match = false;
            break;
          }
        }
      }

      if (match) {
        matchedVariant = variant;
        break;
      }
    }

    // If no exact match, disable cart
    if (!matchedVariant) {
      var addToCart = document.querySelector('[data-add-to-cart]');
      if (addToCart) {
        addToCart.disabled = true;
        addToCart.textContent = 'UNAVAILABLE';
      }
      var buyNow = document.querySelector('[data-buy-now]');
      if (buyNow) buyNow.style.display = 'none';
      return;
    }

    if (matchedVariant) {
      // Update hidden variant input
      var variantInput = document.querySelector('[data-variant-id]');
      if (variantInput) {
        variantInput.value = matchedVariant.id;
      }

      // Update price
      var priceEl = document.querySelector('[data-product-price]');
      if (priceEl) {
        priceEl.textContent = formatMoney(matchedVariant.price);
      }

      // Update compare price
      var compareEl = document.querySelector('[data-product-compare-price]');
      if (compareEl) {
        if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
          compareEl.textContent = formatMoney(matchedVariant.compare_at_price);
          compareEl.style.display = '';
        } else {
          compareEl.textContent = '';
          compareEl.style.display = 'none';
        }
      }

      // Update add to cart button
      var addToCart = document.querySelector('[data-add-to-cart]');
      if (addToCart) {
        var addText = addToCart.getAttribute('data-add-text') || 'ADD TO CART';
        var soldText = addToCart.getAttribute('data-sold-text') || 'SOLD OUT';
        if (matchedVariant.available) {
          addToCart.disabled = false;
          addToCart.textContent = addText;
        } else {
          addToCart.disabled = true;
          addToCart.textContent = soldText;
        }
      }

      // Update discount badge
      var discountEl = document.querySelector('[data-product-discount]');
      if (discountEl) {
        if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
          var pct = Math.round((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price * 100);
          discountEl.textContent = '-' + pct + '%';
          discountEl.style.display = '';
        } else {
          discountEl.textContent = '';
          discountEl.style.display = 'none';
        }
      }

      // Update buy now button visibility
      var buyNow = document.querySelector('[data-buy-now]');
      if (buyNow) {
        buyNow.style.display = matchedVariant.available ? '' : 'none';
      }

      // Update SALE badge visibility
      var saleBadge = document.querySelector('.product__image-badge--sale');
      if (saleBadge) {
        saleBadge.style.display = (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) ? '' : 'none';
      }

      // Update sticky bar price & availability
      var stickyPrice = document.querySelector('[data-sticky-price]');
      if (stickyPrice) {
        stickyPrice.textContent = formatMoney(matchedVariant.price);
      }
      var stickyBtn = document.querySelector('[data-sticky-add]');
      if (stickyBtn) {
        if (matchedVariant.available) {
          stickyBtn.disabled = false;
          stickyBtn.textContent = 'ADD TO CART';
        } else {
          stickyBtn.disabled = true;
          stickyBtn.textContent = 'SOLD OUT';
        }
      }

      // Update featured image via thumbnail click or image map
      if (matchedVariant.featured_image) {
        switchToImage(matchedVariant.featured_image.id);
      }

      // Update URL without reload
      if (window.history && window.history.replaceState) {
        var newUrl = window.location.pathname + '?variant=' + matchedVariant.id;
        window.history.replaceState({ variant: matchedVariant.id }, '', newUrl);
      }
    }
  }

  function formatMoney(cents) {
    var amount = (cents / 100).toFixed(2);
    return 'Rs. ' + amount.replace(/\.00$/, '').replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  // ============================================
  // PRODUCT TABS
  // ============================================
  function initProductTabs() {
    var tabBtns = document.querySelectorAll('[data-tab]');
    if (!tabBtns.length) return;

    tabBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tabId = this.getAttribute('data-tab');

        // Update buttons
        tabBtns.forEach(function(b) { b.classList.remove('active'); });
        this.classList.add('active');

        // Update content
        document.querySelectorAll('[data-tab-content]').forEach(function(content) {
          content.classList.remove('active');
        });
        var target = document.querySelector('[data-tab-content="' + tabId + '"]');
        if (target) {
          target.classList.add('active');
        }
      });
    });
  }

  // ============================================
  // SIZE CHART MODAL
  // ============================================
  function initSizeChart() {
    var toggles = document.querySelectorAll('[data-size-chart-toggle]');
    var modal = document.querySelector('[data-size-chart-modal]');
    var closeBtn = document.querySelector('[data-size-chart-close]');
    if (!modal) return;

    toggles.forEach(function(toggle) {
      toggle.addEventListener('click', function(e) {
        e.preventDefault();
        modal.classList.add('active');
        document.body.style.overflow = 'hidden';
      });
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function() {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      });
    }

    modal.addEventListener('click', function(e) {
      if (e.target === modal) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.classList.contains('active')) {
        modal.classList.remove('active');
        document.body.style.overflow = '';
      }
    });
  }

  // ============================================
  // ADD TO CART (AJAX)
  // ============================================
  function initAddToCart() {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      e.preventDefault();

      var addBtn = form.querySelector('[data-add-to-cart]');
      if (!addBtn || addBtn.disabled) return;

      var originalText = addBtn.textContent;
      addBtn.textContent = 'ADDING...';
      addBtn.disabled = true;

      var formData = new FormData(form);

      // Check if cart drawer exists
      var cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer) {
        // Add sections to render for cart drawer
        var sectionsToRender = cartDrawer.getSectionsToRender().map(function(section) {
          return section.id;
        });
        formData.append('sections', sectionsToRender.join(','));
        formData.append('sections_url', window.location.pathname);
      }

      fetch('/cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(data) {
        if (data.status) {
          // Error from Shopify (e.g. sold out)
          addBtn.textContent = data.message || 'ERROR';
          setTimeout(function() {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 2000);
          return;
        }

        addBtn.textContent = 'ADDED!';
        setTimeout(function() {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1500);

        // Open cart drawer if available
        if (cartDrawer) {
          cartDrawer.renderContents(data);
        } else {
          // Update cart count in header for non-drawer mode
          updateCartCount();
        }
      })
      .catch(function(error) {
        addBtn.textContent = 'ERROR';
        setTimeout(function() {
          addBtn.textContent = originalText;
          addBtn.disabled = false;
        }, 1500);
      });
    });
  }

  // ============================================
  // BUY IT NOW
  // ============================================
  function initBuyNow() {
    var buyNowBtn = document.querySelector('[data-buy-now]');
    if (!buyNowBtn) return;

    buyNowBtn.addEventListener('click', function() {
      var variantInput = document.querySelector('[data-variant-id]');
      var quantity = document.querySelector('[data-quantity-select]');
      if (!variantInput) return;

      var variantId = variantInput.value;
      var qty = quantity ? parseInt(quantity.value) : 1;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: parseInt(variantId), quantity: qty }] })
      })
        .then(function(response) { return response.json(); })
        .then(function() { window.location.href = '/checkout'; })
        .catch(function(err) { console.error('Buy now error:', err); });
    });
  }

  // ============================================
  // SHARE BUTTON
  // ============================================
  function initShareButton() {
    var shareBtn = document.querySelector('[data-share-btn]');
    if (!shareBtn) return;

    shareBtn.addEventListener('click', function() {
      if (navigator.share) {
        navigator.share({
          title: document.title,
          url: window.location.href
        });
      } else {
        // Copy to clipboard fallback
        var tempInput = document.createElement('input');
        tempInput.value = window.location.href;
        document.body.appendChild(tempInput);
        tempInput.select();
        document.execCommand('copy');
        document.body.removeChild(tempInput);

        var originalHTML = shareBtn.innerHTML;
        shareBtn.innerHTML = 'COPIED! <i class="fas fa-check"></i>';
        setTimeout(function() {
          shareBtn.innerHTML = originalHTML;
        }, 2000);
      }
    });
  }

  // ============================================
  // CART COUNT UPDATE
  // ============================================
  function updateCartCount() {
    fetch('/cart.js')
    .then(function(res) { return res.json(); })
    .then(function(cart) {
      // Update custom header cart count
      var countEl = document.querySelector('.header__cart-count');
      if (cart.item_count > 0) {
        if (!countEl) {
          var cartBtn = document.querySelector('.header__action-btn[aria-label="Cart"]');
          if (cartBtn) {
            countEl = document.createElement('span');
            countEl.className = 'header__cart-count';
            cartBtn.appendChild(countEl);
          }
        }
        if (countEl) {
          countEl.textContent = cart.item_count;
        }
      } else if (countEl) {
        countEl.remove();
      }

      // Update Dawn cart-icon-bubble count
      var bubble = document.getElementById('cart-icon-bubble');
      if (bubble) {
        var bubbleCount = bubble.querySelector('.cart-count-bubble');
        if (cart.item_count > 0) {
          if (!bubbleCount) {
            bubbleCount = document.createElement('div');
            bubbleCount.className = 'cart-count-bubble';
            bubble.appendChild(bubbleCount);
          }
          bubbleCount.innerHTML = '<span aria-hidden="true">' + cart.item_count + '</span>';
          // Switch to filled cart icon
          var svgWrapper = bubble.querySelector('.svg-wrapper');
          if (svgWrapper) {
            fetch('/?section_id=cart-icon-bubble')
              .then(function(r) { return r.text(); })
              .then(function(html) {
                var doc = new DOMParser().parseFromString(html, 'text/html');
                var newBubble = doc.getElementById('cart-icon-bubble');
                if (newBubble) {
                  bubble.innerHTML = newBubble.innerHTML;
                }
              });
          }
        } else if (bubbleCount) {
          bubbleCount.remove();
        }
      }
    })
    .catch(function() {});
  }

  // ============================================
  // PRODUCT RECOMMENDATIONS (Shopify API)
  // ============================================
  function initProductRecommendations() {
    var container = document.querySelector('[data-product-recommendations]');
    if (!container) return;

    var productId = null;
    if (window.productData && window.productData.id) {
      productId = window.productData.id;
    }
    if (!productId) return;

    var url = '/recommendations/products.json?product_id=' + productId + '&limit=4';

    fetch(url)
    .then(function(res) { return res.json(); })
    .then(function(data) {
      if (!data.products || data.products.length === 0) return;

      var grid = container.querySelector('[data-recommendations-grid]');
      if (!grid) return;

      grid.innerHTML = '';

      data.products.forEach(function(product) {
        var imgSrc = '';
        if (product.featured_image) {
          imgSrc = product.featured_image.replace(/(\.[^.]+)$/, '_400x$1');
        }

        var card = document.createElement('a');
        card.href = '/products/' + product.handle;
        card.className = 'product-card';
        card.innerHTML =
          '<div class="product-card__image">' +
            (imgSrc ? '<img src="' + imgSrc + '" alt="' + (product.title || '').replace(/"/g, '&quot;') + '" width="400" loading="lazy">' : '') +
          '</div>' +
          '<h3 class="product-card__title">' + product.title + '</h3>' +
          '<p class="product-card__price">Rs. ' + (product.price / 100).toLocaleString('en-IN') + '</p>';

        grid.appendChild(card);
      });
    })
    .catch(function() {});
  }

  // ============================================
  // NEWSLETTER FORM
  // ============================================
  function initNewsletter() {
    var form = document.getElementById('footer-newsletter');
    if (!form) return;

    form.addEventListener('submit', function(e) {
      var btn = form.querySelector('.footer__subscribe-btn');
      if (btn) {
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i>';
      }
    });
  }

  // ============================================
  // SMOOTH SCROLL FOR ANCHOR LINKS
  // FIX: Skip bare '#' hrefs to prevent querySelector crash
  // that was blocking the MP Size Chart app click handler
  // ============================================
  function initSmoothScroll() {
    document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
      anchor.addEventListener('click', function(e) {
        var href = this.getAttribute('href');
        if (!href || href === '#') return; // ← FIX: skip bare # links
        var target = document.querySelector(href);
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  }

  // ============================================
  // STYLED-BY VIDEO HOVER PLAY/PAUSE
  // ============================================
  function initStyledByVideos() {
    var items = document.querySelectorAll('.styled-by__item');
    items.forEach(function(item) {
      var video = item.querySelector('.styled-by__video');
      if (!video) return;

      item.addEventListener('mouseenter', function() {
        video.play().catch(function() {});
      });

      item.addEventListener('mouseleave', function() {
        video.pause();
      });

      // Mobile: play on tap, pause on second tap
      item.addEventListener('touchstart', function() {
        if (video.paused) {
          video.play().catch(function() {});
        } else {
          video.pause();
        }
      }, { passive: true });
    });
  }

  // ============================================
  // SMOOTH DRAG-TO-SCROLL (desktop)
  // ============================================
  function initSmoothDragScroll() {
    var containers = document.querySelectorAll(
      '.featured-collection__grid, .collection-list__grid, .categories__grid, .styled-by__grid, .product-recommendations__grid'
    );

    containers.forEach(function(el) {
      var isDown = false;
      var startX = 0;
      var scrollStart = 0;
      var velX = 0;
      var lastX = 0;
      var rafId = null;

      el.style.cursor = 'grab';

      el.addEventListener('mousedown', function(e) {
        isDown = true;
        el.style.cursor = 'grabbing';
        startX = e.pageX - el.offsetLeft;
        scrollStart = el.scrollLeft;
        velX = 0;
        lastX = e.pageX;
        if (rafId) cancelAnimationFrame(rafId);
      });

      el.addEventListener('mouseleave', function() {
        if (isDown) {
          isDown = false;
          el.style.cursor = 'grab';
          coast();
        }
      });

      el.addEventListener('mouseup', function() {
        if (isDown) {
          isDown = false;
          el.style.cursor = 'grab';
          coast();
        }
      });

      el.addEventListener('mousemove', function(e) {
        if (!isDown) return;
        e.preventDefault();
        var x = e.pageX - el.offsetLeft;
        var walk = (x - startX) * 0.8;
        velX = e.pageX - lastX;
        lastX = e.pageX;
        el.scrollLeft = scrollStart - walk;
      });

      function coast() {
        if (Math.abs(velX) < 0.5) return;
        velX *= 0.92;
        el.scrollLeft -= velX;
        rafId = requestAnimationFrame(coast);
      }
    });
  }

  // ============================================
  // SHIPPING COUNTDOWN TIMER
  // ============================================
  function initShippingCountdown() {
    var el = document.querySelector('[data-shipping-countdown]');
    if (!el) return;
    var timerEl = el.querySelector('[data-countdown-timer]');
    if (!timerEl) return;

    var cutoffHour = parseInt(el.getAttribute('data-cutoff-hour'), 10) || 17;

    function updateTimer() {
      var now = new Date();
      var cutoff = new Date();
      cutoff.setHours(cutoffHour, 0, 0, 0);

      // If past cutoff, move to next day
      if (now >= cutoff) {
        cutoff.setDate(cutoff.getDate() + 1);
      }

      var diff = cutoff - now;
      var hours = Math.floor(diff / (1000 * 60 * 60));
      var minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      var seconds = Math.floor((diff % (1000 * 60)) / 1000);

      timerEl.textContent = hours + 'h ' + minutes + 'm ' + seconds + 's';
    }

    updateTimer();
    setInterval(updateTimer, 1000);
  }

  // ============================================
  // IMAGE ZOOM ON HOVER (desktop)
  // ============================================
  function initImageZoom() {
    // Only on desktop (no touch)
    if ('ontouchstart' in window) return;

    var wrapper = document.querySelector('[data-zoom-wrapper]');
    if (!wrapper) return;

    // Create the zoom lens overlay
    var lens = document.createElement('div');
    lens.className = 'product__zoom-lens';
    wrapper.appendChild(lens);

    wrapper.addEventListener('mouseenter', function() {
      var img = wrapper.querySelector('[data-main-image]');
      if (!img) return;
      var zoomSrc = img.getAttribute('data-zoom-src');
      if (!zoomSrc) return;
      lens.style.backgroundImage = 'url(' + zoomSrc + ')';
      lens.classList.add('active');
    });

    wrapper.addEventListener('mousemove', function(e) {
      if (!lens.classList.contains('active')) return;
      var rect = wrapper.getBoundingClientRect();
      var x = (e.clientX - rect.left) / rect.width;
      var y = (e.clientY - rect.top) / rect.height;

      // Zoom factor 2x
      lens.style.backgroundSize = (rect.width * 2) + 'px ' + (rect.height * 2) + 'px';
      lens.style.backgroundPosition = (x * 100) + '% ' + (y * 100) + '%';
    });

    wrapper.addEventListener('mouseleave', function() {
      lens.classList.remove('active');
    });
  }

  // ============================================
  // STICKY MOBILE ADD-TO-CART BAR
  // ============================================
  function initStickyCart() {
    var stickyBar = document.querySelector('[data-sticky-cart]');
    if (!stickyBar) return;

    var addToCartBtn = document.querySelector('[data-add-to-cart]');
    if (!addToCartBtn) return;

    var stickyBtn = stickyBar.querySelector('[data-sticky-add]');
    var ticking = false;

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(function() {
        var btnRect = addToCartBtn.getBoundingClientRect();
        // Show sticky bar when main add-to-cart is scrolled out of view
        if (btnRect.bottom < 0) {
          stickyBar.classList.add('visible');
        } else {
          stickyBar.classList.remove('visible');
        }
        ticking = false;
      });
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    // Sticky button triggers the main form submit
    if (stickyBtn) {
      stickyBtn.addEventListener('click', function() {
        if (stickyBtn.disabled) return;
        addToCartBtn.click();
      });
    }
  }

  // ============================================
  // HERO BANNER SLIDESHOW
  // ============================================
  function initHeroSlideshow() {
    var slideshows = document.querySelectorAll('[data-hero-slideshow]');
    slideshows.forEach(function(slideshow) {
      var slides = slideshow.querySelectorAll('.hero-banner__slide');
      var dots = slideshow.querySelectorAll('.hero-banner__dot');
      if (slides.length <= 1) return;

      var currentIndex = 0;
      var autoplay = slideshow.getAttribute('data-autoplay') === 'true';
      var interval = parseInt(slideshow.getAttribute('data-interval'), 10) || 3;
      var timer = null;

      function goToSlide(index) {
        slides[currentIndex].classList.remove('active');
        if (dots[currentIndex]) dots[currentIndex].classList.remove('active');
        currentIndex = index;
        if (currentIndex >= slides.length) currentIndex = 0;
        if (currentIndex < 0) currentIndex = slides.length - 1;
        slides[currentIndex].classList.add('active');
        if (dots[currentIndex]) dots[currentIndex].classList.add('active');
      }

      function nextSlide() {
        goToSlide(currentIndex + 1);
      }

      function startAutoplay() {
        if (autoplay && !timer) {
          timer = setInterval(nextSlide, interval * 1000);
        }
      }

      function stopAutoplay() {
        if (timer) {
          clearInterval(timer);
          timer = null;
        }
      }

      // Dot click navigation
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          var index = parseInt(this.getAttribute('data-slide-dot'), 10);
          stopAutoplay();
          goToSlide(index);
          startAutoplay();
        });
      });

      // Pause on hover
      slideshow.addEventListener('mouseenter', stopAutoplay);
      slideshow.addEventListener('mouseleave', startAutoplay);

      // Touch swipe support
      var touchStartX = 0;
      slideshow.addEventListener('touchstart', function(e) {
        touchStartX = e.changedTouches[0].screenX;
        stopAutoplay();
      }, { passive: true });
      slideshow.addEventListener('touchend', function(e) {
        var touchEndX = e.changedTouches[0].screenX;
        var diff = touchStartX - touchEndX;
        if (Math.abs(diff) > 50) {
          if (diff > 0) {
            goToSlide(currentIndex + 1);
          } else {
            goToSlide(currentIndex - 1);
          }
        }
        startAutoplay();
      }, { passive: true });

      // Start autoplay
      startAutoplay();
    });
  }

  // ============================================
  // INITIALIZE ALL
  // ============================================
  function init() {
    initTransparentHeader();
    initMobileMenu();
    initHeroSlideshow();
    initProductGallery();
    initMobileImageSlider();
    initSizeRowVisibility();
    initVariantSelectors();
    initProductTabs();
    initSizeChart();
    initAddToCart();
    initBuyNow();
    initShippingCountdown();
    initImageZoom();
    initStickyCart();
    initShareButton();
    initProductRecommendations();
    initNewsletter();
    initSmoothScroll();
    initSmoothDragScroll();
    initStyledByVideos();
  }

  // Run on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();